import React, {useState, useEffect} from 'react';

import axios from 'axios';

import VisibilitySensor from "react-visibility-sensor";

import {Leaderboard, OverallLeaderboard} from '../components';

import Logo from '../../img/logo.png';

import Regel1 from '../../img/regel-1.jpg';
import Regel2 from '../../img/regel-2.jpg';
import Regel3 from '../../img/regel-3.jpg';
import Regel4 from '../../img/regel-4.jpg';

import moment from "moment";

function Home() {

    const [segments, setSegments] = useState([]);

    const [searchString, setSearchString] = useState('');

    useEffect(() => {

        axios.get(`/api/segments`)
            .then(result => setSegments(result.data));

    }, []);

    return (
        <div className={'container-fluid'}>

            <div className="row header align-items-center justify-content-center mb-5">
                <div className="col-sm-6">
                    <img src={Logo} alt=""/>
                </div>
            </div>

            <div className="container">

                <div className="row justify-content-center mb-5">

                    <div className="col-md-6">

                        <ul>
                            <li><a href="#meisterschaften">Was sind die Schwäbischen Meisterschaften im
                                Bergzeitfahren?</a></li>
                            <li><a href="#teilnahme">Wie nehme ich teil?</a></li>
                            <li><a href="#corona">Warum ist das wichtig während der Corona-Krise?</a></li>
                            <li><a href="#regelwerk">Regelwerk</a></li>
                            <li><a href="#gesamtwertung">Gesamtwertung</a></li>
                            <li>Segmente</li>
                        </ul>

                    </div>

                </div>

                <div className="row justify-content-center mb-5">

                    <div className="col-md-6">

                        <h3 id={'meisterschaften'}>Was sind die Schwäbischen Meisterschaften im Bergzeitfahren?</h3>

                        <p>Ein virtuell ausgewerteter Wettbewerb unter strengen UCI Auflagen zur Ermittlung des
                            schnellsten Radlers im Schwabenland. Aufgrund der Kontaktbeschränkung durch COVID-19 können
                            wir unsere Rennen nicht wie gewohnt in Gemeinschaft austragen. Die Sportlichkeit und Fitness
                            soll aber nicht leiden. <br/>Bis die Kontaktbeschränkung aufgehoben wird, kommunizieren wir
                            jede Woche ein neues Strava-Segment*, auf dem wir uns messen. Entsprechend deiner
                            Platzierung vergeben wir Punkte nach <s>UCI Nations Cup Tabelle</s> umgekehrter Platzierung,
                            die wir zu einer Gesamtwertung summieren.</p>
                        <p><small>* Ein Segment ist ein definierter (Straßen-)Abschnitt, für den durch Auswertung deiner
                            hochgeladenen GPS Daten die benötigte Zeit berechnet wird.</small></p>

                    </div>

                </div>

                <div className="row justify-content-center mb-5">

                    <div className="col-md-6">

                        <h3 id={'teilnahme'}>Wie nehme ich teil?</h3>

                        <ul>
                            <li>Werde Mitglied des <a href="https://www.strava.com/clubs/kesseln">Kesseln.CC
                                Strava-Clubs</a></li>
                            <li>Jeden Sonntag veröffentlichen wir ein Segment auf <a
                                href="https://www.facebook.com/Kesseln.cc">Facebook</a>, <a
                                href="https://www.instagram.com/kesseln.cc/">Instagram</a> und <a
                                href="https://www.strava.com/clubs/kesseln">Strava</a></li>
                            <li>Du hast eine Woche Zeit, das Segment zu fahren</li>
                            <li>Deine beste Leistung der Woche wird über Strava ausgewertet</li>
                            <li>Für deine Platzierung vergeben wir Punkte <s>nach <a
                                href="https://en.wikipedia.org/wiki/UCI_World_Ranking#Explanation_of_the_men's_ranking_points_system">UCI
                                Nations Cup Tabelle</a></s> (Änderung 17. April) entsprechend deiner umgekehrten
                                Platzierung. Mehr Teilnehmer, mehr Punkte – und der Letzte kriegt auch noch was.
                            </li>
                            <li>Der Wettbewerb endet mit der Kontaktbeschränkung</li>
                        </ul>

                    </div>

                </div>

                <div className="row justify-content-center mb-5">

                    <div className="col-md-6">

                        <h3 id={'corona'}>Warum ist das wichtig während der Corona-Krise?</h3>

                        <p>Unser soziales Miteinander leidet unter der Kontaktbeschränkung, unser Alltag wird monoton
                            zwischen Homeoffice und Netflix. Es ist wichtig, nach draußen zu gehen und sich zu bewegen.
                            Dadurch bleibst du gesund und stärkst deine Corona-Abwehrkräfte. Durch den virtuellen
                            Wettbewerb wird das spannend und abwechslunsgreich. Dazu bekommst deine tägliche Dosis
                            Motivation und Frustration.</p>
                    </div>

                </div>

                <div className="row justify-content-center">

                    <div className="col-md-6">
                        <h3 id={'regelwerk'}>Regelwerk</h3>

                        <p>Damit wir den Wettbewerb fair und sicher durchführen können, ist es wichtig, dass du dich an
                            das Regelwerk hältst. Fahr alleine, betrüge nicht mit Windschatten und halte die
                            Kontaktbeschränkung ein. Riskiere keinen Unfall oder Verletzungen und gibt acht auf andere
                            Verkehrsteilnehmer. Die Rettungskräfte und Krankenhäuser haben wichtigeres zu tun. Verteile
                            Kudos auf Strava – jeder, der sich die Segemente hochquält verdient Respekt!</p>
                    </div>

                </div>

            </div>

            <div className="row justify-content-center mb-5">

                <div className="col-sm-6 col-md-3 mb-5">
                    <img src={Regel1} alt=""/>
                </div>
                <div className="col-sm-6 col-md-3 mb-5">
                    <img src={Regel2} alt=""/>
                </div>
                <div className="col-sm-6 col-md-3 mb-5">
                    <img src={Regel3} alt=""/>
                </div>
                <div className="col-sm-6 col-md-3 mb-5">
                    <img src={Regel4} alt=""/>
                </div>

            </div>

            <div className="container">
                <div className="row my-5">
                    <div className="col-12">
                        <label htmlFor="">
                            Wertung nach Name filtern <small className={'text-muted'}>Mehrere Namen mit Komma  und ohne Leerzeichen trennen</small>
                        </label>
                        <div className="input-group input-group-lg">
                            <input
                                type="text"
                                className="form-control"
                                aria-label="Mädla und Buabe durchsuchen"
                                aria-describedby="inputGroup-sizing-lg"
                                value={searchString}
                                onChange={(event) => event.target.value !== searchString && setSearchString(event.target.value)}
                            />
                            <div className="input-group-append">
                                <button className="btn btn-secondary" type="button" id="button-addon2" onClick={() => setSearchString('')}>☠️</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">

                <div className="row">

                    <div className="col-12">

                        <h1 className={'mb-3'} id={'gesamtwertung'}>Gesamt&shy;wertung</h1>

                    </div>

                </div>

                <div className={'row mb-5'}>

                    <div className="col-sm-6">
                        <OverallLeaderboard gender={'M'} searchString={searchString}/>
                    </div>

                    <div className="col-sm-6">
                        <OverallLeaderboard gender={'F'} searchString={searchString}/>
                    </div>

                </div>

                {segments.map((segment, i) => (


                    <VisibilitySensor key={i} minTopValue={100} partialVisibility={true}>

                        {({isVisible}) => <div className={`mb-5 pt-5`}>

                            <div className={`${isVisible && 'sticky-top'} mb-4`}>

                                <h2 className={'text-warning'} style={{margin: '-1rem', padding: '1rem', overflow: 'hidden'}}>
                                    {segment.visible
                                        ? <span className={'bg-dark'} style={{margin: '-1rem', padding: '1rem', whiteSpace: 'nowrap'}}><span className={'d-none d-md-inline'}>Segment {segment.index}: </span><a className={'text-warning'} href={`https://strava.com/segments/${segment.id}`} target={'_blank'}>{segment.name}</a></span>
                                        : <span className={'bg-dark'} style={{margin: '-1rem', padding: '1rem'}}>Segment {segment.index}</span>
                                    }
                                </h2>

                            </div>

                            <p className={'mb-5'}>
                                {segment.active
                                    ? <span><strong>noch {moment.duration(moment().diff(moment(segment.end_at))).humanize()} </strong> bis {moment(segment.end_at).format('dddd H:mm')} Uhr</span>
                                    : `von ${moment(segment.start_at).format('dddd, Do MMMM H:mm')} Uhr bis ${moment(segment.end_at).format('dddd, Do MMMM H:mm')} Uhr`
                                }
                            </p>

                            {segment.visible && (

                                <div className={'row'}>

                                    <div className="col-md-12 col-lg-6">
                                        <Leaderboard key={segment.id + 'M'} segment={segment} gender={'M'} searchString={searchString}/>
                                    </div>

                                    <div className="col-md-12 col-lg-6">
                                        <Leaderboard key={segment.id + 'F'} segment={segment} gender={'F'} searchString={searchString}/>
                                    </div>

                                </div>

                            )}

                        </div>}

                    </VisibilitySensor>

                ))}

            </div>

            <div className="container">

                <div className="row justify-content-center mb-5">

                    <div className="col-sm-6">

                        <strong>Kesseln Cycling Collective</strong> <br/>
                        &#x68;&#x61;&#x6c;&#x6c;&#x6f;&#x40;&#x6b;&#x65;&#x73;&#x73;&#x65;&#x6c;&#x6e;&#x2e;&#x63;&#x63;
                        <br/>
                        Kronprinzstraße 13 <br/>
                        70173 Stuttgart <br/>

                    </div>

                </div>

            </div>

        </div>
    );
}

export default Home;
